import { styled } from "@mui/system";
import { Button, Typography, Container, Grid, IconButton } from "@mui/material";

export const ButtonContainer = styled(Grid)`
  display: flex;
  //   flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
`;

export const ButtonWrapper = styled(Grid)``;

export const LogOutButtonElement = styled(Button)`
  width: 100px;
`;
